import { IconButton } from '@genial/components';
import { Spacing, Typography, Color } from '@genial/design-tokens';
import { Pressable, Text } from 'native-base';
import React from 'react';

interface TriggerButtonFilesProps {
  triggerProps?: any;
  onOpen?: () => void;
}

export const TriggerButtonFiles: React.FC<TriggerButtonFilesProps> = ({ triggerProps, onOpen }) => {
  return (
    <Pressable
      {...triggerProps}
      onPress={onOpen}
      justifyContent="space-between"
      alignItems="center"
      flexDirection={'row'}
      w="full"
      p={Spacing['stack.nano']}
      mt={Spacing['inline.xxxs']}>
      <Text
        color="brand.tertiary.principal"
        variant="semibold"
        fontSize={Typography['fontsize.md']}>
        TERMOS E DOCUMENTOS
      </Text>
      <IconButton
        onPress={onOpen}
        p={0}
        testId="arrow-right"
        icon="ChevronRight"
        iconColor={Color['brand.tertiary.principal']}
        iconSize="xxs"
      />
    </Pressable>
  );
};
